import FaqSection from '../../faq/FaqSection'

export type DataSectionItem = {
  label: string
  content: string
}
export type FaqContentSectionType = {
  type: 'faqs'
  title: string
  listItems: DataSectionItem[]
}

export const FaqContentSection = ({
  title,
  listItems,
}: FaqContentSectionType) => {
  const items = listItems.map((item) => ({
    question: item.label,
    answer: item.content,
  }))
  return <FaqSection title={title} items={items} />
}
